import { Injectable } from '@angular/core';
import { EMPTY, Observable, Observer, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Socket } from 'ngx-socket-io';
import { ConnectionEvent } from '../enums/socket.enum';


@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  public messages: Subject<any>;

  constructor(
    private socket: Socket
  ) {}

  public sendChat(message): void {
    this.socket.emit('order', message);
  }
  public connect(message): void {
    this.socket.emit(ConnectionEvent.connection, message);
  }
  public receiveOrder(): Observable<any> {
    return this.socket.fromEvent('order');
  }
  public receiveGroupOrder(): Observable<any> {
    return this.socket.fromEvent('group');
  }
}
